import type { MinorAmount } from "../../bet/BetSystemTypes";

export type CurrentWinSnapshot = {
  visible: boolean;
  currentWinMinor: MinorAmount; // "0" if none
};

export class CurrentWinStore {
  private snapshot: CurrentWinSnapshot = { visible: false, currentWinMinor: "0" };
  private listeners: Array<(s: CurrentWinSnapshot) => void> = [];

  public getSnapshot(): CurrentWinSnapshot {
    return this.snapshot;
  }

  public setWinMinor(winMinor: MinorAmount): void {
    this.snapshot = { visible: true, currentWinMinor: winMinor };
    this.emit();
  }

  public hide(): void {
    if (!this.snapshot.visible) return;
    this.snapshot = { ...this.snapshot, visible: false };
    this.emit();
  }

  public clear(): void {
    this.snapshot = { visible: false, currentWinMinor: "0" };
    this.emit();
  }

  public subscribe(listener: (s: CurrentWinSnapshot) => void): () => void {
    this.listeners.push(listener);
    return () => {
      const i = this.listeners.indexOf(listener);
      if (i >= 0) this.listeners.splice(i, 1);
    };
  }

  private emit(): void {
    const s = this.snapshot;
    for (const l of this.listeners) l(s);
  }
}